namespace GeniuzPOS.Purchase {
    export class ReportPendingPRColumns {
        static columnsKey = 'Purchase.ReportPendingPR';
    }
}
